/* gg-perf (FR-7): desktop "Show more" and the phone filter drawer load their full value lists on demand. */
(() => {
  const documents = new Map();

  function sectionUrl() {
    const grid = document.getElementById('product-grid');
    if (!grid || !grid.dataset.id) return null;
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', grid.dataset.id);
    return url.toString();
  }

  function loadSectionDocument() {
    const url = sectionUrl();
    if (!url) return Promise.reject(new Error('product grid not found'));
    if (!documents.has(url)) {
      const request = fetch(url, { credentials: 'same-origin' })
        .then((response) => { if (!response.ok) throw new Error(`HTTP ${response.status}`); return response.text(); })
        .then((html) => new DOMParser().parseFromString(html, 'text/html'));
      documents.set(url, request);
      request.catch(() => documents.delete(url));
    }
    return documents.get(url);
  }

  async function showMore(button) {
    const detailsId = button.getAttribute('data-gg-facet-show-more');
    const current = document.getElementById(detailsId);
    if (!current || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    button.querySelector('.gg-loading-label')?.removeAttribute('hidden');
    button.querySelector('.label-show-more')?.setAttribute('hidden', '');
    current.querySelector('.gg-facet-error')?.remove();
    try {
      const fresh = (await loadSectionDocument()).getElementById(detailsId);
      const freshList = fresh && fresh.querySelector('.details__list');
      const currentList = current.querySelector('.details__list');
      if (!freshList || !currentList) throw new Error(`${detailsId} list not in response`);
      const shownBefore = current.querySelectorAll('input[type="checkbox"]').length;
      // Replace only the list under the heading, so the heading keeps Ella's listeners, animation and aria-expanded
      currentList.innerHTML = freshList.innerHTML;
      current.querySelectorAll('.show-more-item.hidden').forEach((item) => item.classList.remove('hidden'));
      const toggle = current.querySelector('show-more-button');
      if (toggle) toggle.querySelectorAll('.label-text').forEach((label) => label.classList.toggle('hidden'));
      const firstNew = current.querySelectorAll('input[type="checkbox"]')[shownBefore];
      if (firstNew) firstNew.focus({ preventScroll: true });
    } catch (error) {
      button.removeAttribute('aria-busy');
      button.querySelector('.gg-loading-label')?.setAttribute('hidden', '');
      button.querySelector('.label-show-more')?.removeAttribute('hidden');
      button.insertAdjacentHTML('afterend', '<p class="gg-facet-error" role="alert">Couldn’t load more values. Please try again.</p>');
    }
  }

  const mobileWrapper = () => document.getElementById('FacetsWrapperMobile');

  async function loadMobileFilters() {
    const wrapper = mobileWrapper();
    if (!wrapper || !wrapper.hasAttribute('data-gg-deferred') || wrapper.dataset.ggLoading === 'true') return;
    wrapper.dataset.ggLoading = 'true';
    const loading = wrapper.querySelector('.gg-facets-mobile-status__loading');
    const failed = wrapper.querySelector('.gg-facets-mobile-status__error');
    failed?.setAttribute('hidden', '');
    loading?.removeAttribute('hidden');
    try {
      const fresh = (await loadSectionDocument()).getElementById('FacetsWrapperMobile');
      if (!fresh) throw new Error('FacetsWrapperMobile not in response');
      wrapper.replaceWith(fresh);
      const drawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
    } catch (error) {
      wrapper.dataset.ggLoading = 'false';
      loading?.setAttribute('hidden', '');
      failed?.removeAttribute('hidden');
    }
  }

  document.addEventListener('click', (event) => {
    const showMoreButton = event.target.closest('[data-gg-facet-show-more]');
    if (showMoreButton) { event.preventDefault(); showMore(showMoreButton); return; }
    if (event.target.closest('[data-gg-facets-mobile-retry]')) { event.preventDefault(); loadMobileFilters(); }
  });

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (details instanceof HTMLDetailsElement && details.classList.contains('mobile-facets__disclosure') && details.open) loadMobileFilters();
  }, true);

  document.addEventListener('pointerdown', (event) => {
    if (event.target.closest && event.target.closest('.mobile-facets__open-wrapper') && mobileWrapper()?.hasAttribute('data-gg-deferred')) {
      // Show the loader with the tap itself, so it paints in the drawer's first frame
      mobileWrapper().querySelector('.gg-facets-mobile-status__loading')?.removeAttribute('hidden');
      loadSectionDocument().catch(() => {});
    }
  }, { passive: true });
})();
